import { Type } from 'typebox';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const BathroomDescriptions = {
    wet: 'wet',
    dry: 'dry',
    bowelMovements: 'BM',
    diaperCream: 'diaper cream',
    pee: 'pee',
    accident: 'accident',
    tried: 'tried',
    unknown: 'unknown'
};
export const BathroomDescription = Type.Union([
    Type.Literal(BathroomDescriptions.wet),
    Type.Literal(BathroomDescriptions.dry),
    Type.Literal(BathroomDescriptions.bowelMovements),
    Type.Literal(BathroomDescriptions.diaperCream),
    Type.Literal(BathroomDescriptions.pee),
    Type.Literal(BathroomDescriptions.accident),
    Type.Literal(BathroomDescriptions.tried),
    Type.Literal(BathroomDescriptions.unknown)
]);
export const BathroomDescriptionCodec = createFallbackStringEnumCodec(BathroomDescriptions, BathroomDescriptions.unknown);
export const BathroomTypes = {
    diaper: 'diaper',
    toilet: 'potty',
    unknown: 'unknown'
};
export const BathroomType = Type.Union([
    Type.Literal(BathroomTypes.diaper),
    Type.Literal(BathroomTypes.toilet),
    Type.Literal(BathroomTypes.unknown)
]);
export const BathroomTypeCodec = createFallbackStringEnumCodec(BathroomTypes, BathroomTypes.unknown);
export const BathroomEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.bathroom),
        bathroomType: BathroomTypeCodec,
        events: Type.Optional(Type.Array(BathroomDescriptionCodec))
    })
]));
